import React, { forwardRef, Ref } from "react"
import { Icon, IconProps } from "@mezo-org/mezo-clay"

function BitcoinToken(props: IconProps, ref: Ref<SVGSVGElement>) {
  const { title, size = 24, color, ...restProps } = props

  return (
    <Icon
      ref={ref}
      viewBox="0 0 48 48"
      title={title ?? "Bitcoin Token"}
      size={size}
      overrides={{
        Svg: {
          style: () => ({
            fill: color ?? "#FF8A00",
          }),
        },
      }}
      role="graphics-symbol"
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1897 47.2817C31.0484 50.4872 44.0713 42.6632 47.2768 29.806C50.4823 16.9481 42.6576 3.92368 29.7997 0.718193C16.9447 -2.48729 3.92254 5.33817 0.718553 18.1969C-2.48768 31.0533 5.33703 44.0762 18.1897 47.2817ZM29.3005 14.5256C32.6252 15.6709 35.0567 17.3876 34.5797 20.5811C34.234 22.9188 32.9372 24.0506 31.2167 24.4488C33.5792 25.6796 34.7807 27.5658 33.6355 30.8358C32.2157 34.8963 28.8385 35.239 24.3483 34.3893L23.2585 38.7565L20.6253 38.1003L21.7008 33.7915C21.0183 33.622 20.3208 33.442 19.603 33.247L18.523 37.576L15.8928 36.9198L16.9825 32.5435C16.7412 32.4816 16.4982 32.4183 16.2535 32.3544C15.8754 32.2558 15.4931 32.156 15.1061 32.059L11.6786 31.2048L12.9858 28.1898C12.9858 28.1898 14.9261 28.7058 14.8998 28.6675C15.6453 28.852 15.9761 28.366 16.1066 28.042L17.8293 21.1383L18.1068 21.2073C18.0018 21.1653 17.9065 21.1383 17.833 21.1196L19.0615 16.1914C19.0945 15.6319 18.901 14.9261 17.8345 14.6599C17.8758 14.6321 15.9221 14.1844 15.9221 14.1844L16.6225 11.3719L20.254 12.2786L20.251 12.2921C20.797 12.4279 21.3595 12.5569 21.9325 12.6874L23.0118 8.3629L25.6435 9.01915L24.586 13.2589C25.2925 13.4201 26.0035 13.5829 26.695 13.7554L27.745 9.54339L30.379 10.1996L29.3005 14.5256ZM20.9683 30.2095C23.1162 30.7772 27.8149 32.019 28.5625 29.0178C29.3255 25.9502 24.7719 24.9283 22.5499 24.4297C22.3017 24.374 22.0826 24.3248 21.9033 24.2801L20.4573 30.0768C20.604 30.1133 20.7759 30.1587 20.9683 30.2095ZM22.9968 21.7398C24.789 22.218 28.6957 23.2602 29.3762 20.5338C30.072 17.7447 26.2732 16.904 24.4179 16.4934C24.2093 16.4473 24.0253 16.4065 23.875 16.3691L22.564 21.6266C22.6881 21.6575 22.8337 21.6963 22.9968 21.7398Z"
      />
    </Icon>
  )
}

export default forwardRef<SVGSVGElement, IconProps>(BitcoinToken)
